import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Navigate,
} from "react-router-dom";

import { store } from "./redux/store";
import { Provider } from "react-redux";
import NotFound from "./containers/LoginPage/PageNotFound/index";
import CheckConnection from "./components/_utils/CheckConnection";
import FeatureNotAssigned from "./containers/FeatureNotAssigned";
// landing page
import LandingPage from "./containers/LandingPage";
import LandingPageContainer from "./containers/LandingPage/LandingPageContainer";
import AMC from "./containers/LandingPage/pages/AMC";
import Corporates from "./containers/LandingPage/pages/Corporates";
import BankStatement from "./containers/LandingPage/pages/BankStatement";
import ViewAllBalances from "./containers/LandingPage/pages/ViewAllBalances";
import AboutUs from "./containers/LandingPage/pages/AboutUs";
import Advisors from "./containers/LandingPage/pages/Advisors";
import Pricing from "./containers/LandingPage/pages/Pricing";
import ContactUs from "./containers/LandingPage/pages/ContactUs";
import TermsConditions from "./containers/LandingPage/pages/TermsConditions";
import BookDemo from "./containers/LandingPage/pages/BookDemo";
import PrivacyPolicy from "./containers/LandingPage/pages/PrivacyPolicy";
// login
import LoginPage from "./containers/LoginPage";
import LoginTotp from "./containers/LoginTotp/LoginTotp";
import Relogin from "./containers/LoginPage/ReLogin";
import CheckUserLogin from "./containers/LoginPage/checkUserLogin/CheckUserLogin";
import SetNewPassword from "./containers/LoginPage/SetNewPassword";
import FeatureNotAssign from "./containers/LoginPage/FeatureNotAssign/FeatureNotAssign";
import ContactAdmin from "./containers/LoginPage/AdminContact/index";
//multi entity
import AppBar from "./AppBar";
import MultiEntities from "./containers/MultiEntities/MultiEntities";
import MultiEntityViewAll from "./containers/MultiEntities/MultiEntityViewAll";
// homedashboard
import HomeDashboard from "./containers/HomeDashboard";
import UnassignCategories from "./components/HomeDashboard/UnassignCategories";
import FieldForceUnassignCategories from "./components/HomeDashboard/FieldForceUnassignCategories";
import ReminderTransaction from "./containers/ReminderTransaction";
import ProfileQuickMenu from "./containers/ProfileQuickMenu";
import MyProfileDetails from "./containers/MyProfileDetails";
// beneficiary txn
import BeneficiaryTransactionDashboard from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionDashboard";
import BeneficiaryTransactionCreate from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionCreate";
import BeneficiaryTransactionSuccess from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionSuccess";
import BeneficiaryTransactionFailed from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionFailed";
import BeneficiaryTransactionViewall from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall";
import BeneficiaryTransactionDetails from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionDetails";
import BeneficiaryTransactionSingleApproval from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionSingleApproval";
import BeneficiaryTransactionMultiSelect from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionMultiApproval/BeneficiaryMultiSelect";
import BeneficiaryMultiApproval from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionMultiApproval/BeneficiaryMultiApproval";
import BeneficiaryMultiApprovalFailed from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionMultiApproval/BeneficiaryMultiApprovalFailed";
import BeneficiaryMultiApprovalDeclined from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionMultiApproval/BeneficiaryMultiApprovalDeclined";
import BeneficiaryMultiApprovalSuccess from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionMultiApproval/BeneficiaryMultiApprovalSuccess";
import BeneficiaryTransactionRecreateDashboard from "./containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionRecreateDashboard";
import BulkTransactionViewAll from "./containers/Transactions/BulkTransactions/BulkTransactionViewAll";
import BulkTransactionDetails from "./containers/Transactions/BulkTransactions/BulkTransactionDetails";
import BulkTransactionSuccess from "./containers/Transactions/BulkTransactions/BulkTransactionSuccess";
import BulkTransactionFailed from "./containers/Transactions/BulkTransactions/BulkTransactionFailed";
import BulkTrasanctionCreate from "./containers/Transactions/BulkTransactions/BulkTransactionCreate";
//beneficiary schedule
import ScheduleBeneficiaryTransactionViewSchedules from "./containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionViewSchedules";
import ScheduleBeneficiaryTransactionSuccess from "./containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionSuccess";
import ScheduleBeneficiaryTransactionCreate from "./containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionCreate";
import ScheduleBeneficiaryTransactionSingleApproval from "./containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionSingleApproval";
import ScheduleBeneficiaryTransactionDetails from "./containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionDetails";
import ScheduleBeneficiaryTransactionFailed from "./containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionFailed";
import ScheduleBeneficiaryMultiSelect from "./containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionMultiApproval/ScheduleTransactionMultiSelect";
import ScheduleBeneficiaryMultiApproval from "./containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionMultiApproval/ScheduleBeneficiaryMultiApproval";
import ScheduleBeneficiaryMultiApprovalDeclined from "./containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionMultiApproval/ScheduleBeneficiaryMultiApprovalDeclined";
import ScheduleBeneficiaryMultiApprovalFailed from "./containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionMultiApproval/ScheduleBeneficiaryMultiApprovalFailed";
import ScheduleBeneficiaryMultiApprovalSuccess from "./containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionMultiApproval/ScheduleBeneficiaryMultiApprovalSuccess";
// internal txn
import InternalTransactionDashboard from "./containers/Transactions/InternalTransactions/InternalTransactionDashboard";
import InternalTransactionCreate from "./containers/Transactions/InternalTransactions/InternalTransactionCreate";
import InternalTransactionFailed from "./containers/Transactions/InternalTransactions/InternalTransactionFailed";
import InternalTransactionSuccess from "./containers/Transactions/InternalTransactions/InternalTransactionSuccess";
import InternalTransactionViewAll from "./containers/Transactions/InternalTransactions/InternalTransactionViewAll";
import InternalTransactionDetails from "./containers/Transactions/InternalTransactions/InternalTransactionDetails";
import InternalTransactionSingleApproval from "./containers/Transactions/InternalTransactions/InternalTransactionSingleApproval";
import InternalTransactionMultiSelect from "./containers/Transactions/InternalTransactions/InternalTransactionMultiApproval/InternalMultiSelect";
import InternalMultiApproval from "./containers/Transactions/InternalTransactions/InternalTransactionMultiApproval/InternalMultiApproval";
import InternalMultiApprovalSuccess from "./containers/Transactions/InternalTransactions/InternalTransactionMultiApproval/InternalMultiApprovalSuccess";
import InternalMultiApprovalFailed from "./containers/Transactions/InternalTransactions/InternalTransactionMultiApproval/InternalMultiApprovalFailed";
import InternalMultiApprovalDeclined from "./containers/Transactions/InternalTransactions/InternalTransactionMultiApproval/InternalMultiApprovalDeclined";
import InternalTransactionRecreateDashboard from "./containers/Transactions/InternalTransactions/InternalTransactionRecreateDashboard";

//internal schedule
import ScheduleInternalTransactionCreate from "./containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionCreate";
import ScheduleInternalTransactionSuccess from "./containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionSuccess";
import ScheduleInternalTransactionFailed from "./containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionFailed";
import ScheduleInternalTransactionSingleApproval from "./containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionSingleApproval";
import ScheduleInternalTransactionMultiSelect from "./containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionMultiApproval/ScheduleInternalTransactionMultiSelect";
import ScheduleInternalMultiApproval from "./containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionMultiApproval/ScheduleInternalMultiApproval";
import ScheduleInternalTransactionDetails from "./containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionDetails";
import ScheduleInternalTransactionViewSchedules from "./containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionViewSchedules";
import ScheduleInternalMultiApprovalSuccess from "./containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionMultiApproval/ScheduleInternalMultiApprovalSuccess";
import ScheduleInternalMultiApprovalFailed from "./containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionMultiApproval/ScheduleInternalMultiApprovalFailed";
import ScheduleInternalMultiApprovalDeclined from "./containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionMultiApproval/ScheduleInternalMultiApprovalDeclined";

// beneficiary create account
import BeneficiaryAccountDashboard from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountDashboard";
import BeneficiaryAccountCreate from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountCreate";
import BeneficiaryAccountDetails from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountDetails";
import BeneficiaryAccountSuccess from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountSuccess";
import BeneficiaryAccountFailed from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountFailed";
import BeneficiaryAccountViewAll from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountViewAll";
import BeneficiaryAcountApproval from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAcountApproval";
//beneficiary edit account
import BeneficiaryAccountEditBank from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountEdit/BeneficiaryAccountEditBank";
import BeneficiaryAccountEditPAN from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountEdit/BeneficiaryAccountEditPAN";
import BeneficiaryAccountEditContact from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountEdit/BeneficiaryAccountEditContact";
import BeneficiaryAccountEditCategories from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountEdit/BeneficiaryAccountEditCategories";
import BeneficiaryAccountEditBankSuccess from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountEdit/BeneficiaryAccountEditBankSuccess/Index";
import BeneficiaryAccountEditPANSuccess from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountEdit/BeneficiaryAccountEditPANSuccess";
import BeneficiaryAccountEditSuccess from "./containers/Accounts/BeneficiaryAccount/BeneficiaryAccountEdit/BeneficiaryAccountEditSuccess";
//internal account
import InternalAccountDashboard from "./containers/Accounts/InternalAccount/InternalAccountDashboard";
import InternalAccountViewAll from "./containers/Accounts/InternalAccount/InternalAccountViewAll";
import InternalAccountDetails from "./containers/Accounts/InternalAccount/InternalAccountDetails";
import InternalAccountApproval from "./containers/Accounts/InternalAccount/InternalAccountApproval";
import InternalAccountEditContact from "./containers/Accounts/InternalAccount/InternalAccountEdit/InternalAccountEditContact";
import InternalAccountEditSuccess from "./containers/Accounts/InternalAccount/InternalAccountEdit/InternalAccountEditSuccess";
//owner
import OwnerAccountDashboard from "./containers/Accounts/OwnerAccount/OwnerAccountDashboard";
import OwnerAccountViewAll from "./containers/Accounts/OwnerAccount/OwnerAccountViewAll";
import OwnerAccountDetails from "./containers/Accounts/OwnerAccount/OwnerAccountDetails";
import OwnerAccountConsolidatedBankStatement from "./containers/Accounts/OwnerAccount/OwnerAccountConsolidatedBankStatement";
import OwnerAccountBulkUploadStatement from "./containers/Accounts/OwnerAccount/OwnerAccountBulkUploadStatement";
import OwnerAccountBulkUploadStatementSuccess from "./containers/Accounts/OwnerAccount/OwnerAccountBulkUploadStatementSuccess";
// settings
import SettingsDashboard from "./containers/Settings/Dashboard";
import Statistics from "./containers/Settings/Statistics";
import UsersSettings from "./containers/Settings/Users";
import UserDetails from "./containers/Settings/Users/UserDetails";
import RolesDetails from "./containers/Settings/Roles/RolesDetails";
import MyDevices from "./containers/Settings/MyDevices";
import MyDeviceDetails from "./containers/Settings/MyDeviceDetails";
import EntitiesViewAll from "./containers/Settings/Entities/Entities_ViewAll";
import EntityDetails from "./containers/Settings/Entities/EntityDetails";
import CINVerification from "./containers/Settings/CINVerification/index";
import DINVerification from "./containers/Settings/DINVerification/index";
import PanVerification from "./containers/Settings/PanVerification";
import GSTVerification from "./containers/Settings/GSTDetails";
import IFSCVerification from "./containers/Settings/IFSCVerification";
import IFSCDetails from "./containers/Settings/IFSCDetails";
import SettingsSecurityCenter from "./containers/Settings/SecurityCenter";
import TotpCreate from "./containers/Totp/TotpCreate";
import ByokCreate from "./containers/Settings/BYOK";
import ChangePassword from "./containers/LoginPage/ChangePassword/ChangePassword";
import InvoicesDetail from "./containers/Settings/Invoices";
import TestAuthMatrix from "./containers/Settings/TestAuthMatrix";
import TestAuthMatrixOutcomePage from "./containers/Settings/TestAuthMatrix/TestAuthMatrixOutcomePage";
import CustomCategoryViewAll from "./containers/Settings/CustomCategory/CustomCategoryViewAll";
import CustomCategoryDashboard from "./containers/Settings/CustomCategory/CustomCategoryDashboard";
import CustomCategoryCreate from "./containers/Settings/CustomCategory/CustomCategoryCreate";
// import BBPS_DetailPage from "./containers/Accounts/BBPSAccount/BBPS_DetailPage";
// import BBPS_Dashboard from "./containers/Accounts/BBPSAccount/BBPS_Dashboard";
// import BBPS_Create from "./containers/Accounts/BBPSAccount/BBPS_Create";
// import BBPS_Success from "./containers/Accounts/BBPSAccount/BBPS_Success";
// import BBPS_Error from "./containers/Accounts/BBPSAccount/BBPS_Error";
// import BBPS_ViewAll from "./containers/Accounts/BBPSAccount/BBPS_ViewAll/index";
// mixed route
import GenerateMISReport from "./containers/GenerateMISReport";
import Product from "./containers/LandingPage/pages/Product";
import RequireAuth from "./containers/LoginPage/RequireAuth";
import ReimbursementDashboard from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountDashboard";
import CreateSuccess from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountSuccess";
import ReimbursementAccountCreateError from "./containers/Accounts/ReimbursementAccount/ReimbursmentAccountFailure";
import FeaturesDetail from "./containers/Features/FeaturesDetail";
import CreateUsers from "./containers/Settings/Users/CreateUsers";
import UserSucess from "./containers/Settings/Users/UserSucess";
import UserError from "./containers/Settings/Users/UserError";
import Roles from "./containers/Settings/Roles";
import ServicesViewAll from "./containers/Settings/Services";
import FeaturesViewAll from "./containers/Settings/Features";
import ReimbursementAccountApproval from "./containers/Accounts/ReimbursementAccount/ReimbursmentAccountApproval";
import ServiceDetails from "./containers/Settings/Services/ServiceDetails";
// ReimbursementTransactions txn
import ReimbursementTransactionDashboard from "./containers/Transactions/ReimbursementTransactions/ReimbursementTransactionDashboard";
import ReimbursementTransactionViewAll from "./containers/Transactions/ReimbursementTransactions/ReimbursementTransactionViewAll";
import ReimbursementTxnRequestCreate from "./containers/ReimbursementRequest/ReimbursementRequestCreate";
import ReimbursementSuccessPage from "./containers/ReimbursementRequest/ReimbursementSuccess";
import ReimbursementRequestFailure from "./containers/ReimbursementRequest/ReimbursementRequesFailure";
import ReimbursementRequestViewAll from "./containers/ReimbursementRequest/ReimbursementRequestViewAll";
import ReimbursementAccountViewAll from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountViewAll";
import ReimbursementAccountDetails from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountDetails";
import ReimbursementTxnRequestDetail from "./containers/ReimbursementRequest/ReimbursementRequestDetail";
import ReimburseCreateTxn from "./containers/Transactions/ReimbursementTransactions/ReimbursementTransactionCreate";
import ReimbursementTxnSuccessPage from "./containers/Transactions/ReimbursementTransactions/ReimbursementTransactionSuccess";
import ReimbursementTxnErrorPage from "./containers/Transactions/ReimbursementTransactions/ReimbursementTransactionFailure";
import UserEditContact from "./containers/Settings/Users/UserEditContact";
import UserEditContactSuccess from "./containers/Settings/Users/UserEditContactSuccess";
import ReimbursementRequestSingleApproval from "./containers/ReimbursementRequest/ReimbursementRequestSingleApproval";
import ReimbursementTxnSingleApproval from "./containers/Transactions/ReimbursementTransactions/ReimbursementTransactionSingleApproval";
import ReimbursementTxnMultiApproval from "./containers/Transactions/ReimbursementTransactions/ReimbursementTransactionMultiApproval";
import ReimbursementTxnDetails from "./containers/Transactions/ReimbursementTransactions/ReimbursementTransactionDetails";

import ReimbursementTxnMultiApprovalDetail from "./components/ReimbursementTransactionsComp/ ReimbursementTxnMultiApprovalDetail";
import ReimbursementTxnMultiApprovalSuccess from "./components/ReimbursementTransactionsComp/ReimbursementTxnMultiApprovalSuccess";
import ReimbursementTxnMultiApprovalDeclined from "./components/ReimbursementTransactionsComp/ReimbursementTxnMultiApprovalDeclined";
import ReimbursementTxnMultiApprovalError from "./components/ReimbursementTransactionsComp/ ReimbursementTxnMultiApprovalError";
//Tax account
// import TaxationAccountDashboard from "./containers/Accounts/TaxationAccount/TaxationAccountDashboard";
// import TaxationAccountCreate from "./containers/Accounts/TaxationAccount/TaxationAccountCreate";
// import TaxationAccountSuccess from "./containers/Accounts/TaxationAccount/TaxationAccountSuccess";
// import TaxationAccountFailed from "./containers/Accounts/TaxationAccount/TaxationAccountFailed";
// import TaxationAccountViewAll from "./containers/Accounts/TaxationAccount/TaxationAccountViewAll";
// import TaxationAccountDetails from "./containers/Accounts/TaxationAccount/TaxationAccountDetails";
// import TaxationAccountApproval from "./containers/Accounts/TaxationAccount/TaxationAccountApproval";
// import TaxationAccountEditPAN from "./containers/Accounts/TaxationAccount/TaxationAccountEdit/TaxationAccountEditPAN";
// import TaxationEditAccountPANSuccess from "./containers/Accounts/TaxationAccount/TaxationAccountEdit/TaxationAccountEditPANSuccess";
// import TaxationEditAccountBank from "./containers/Accounts/TaxationAccount/TaxationAccountEdit/TaxationAccountEditBank";
// import TaxationEditAccountBankSuccess from "./containers/Accounts/TaxationAccount/TaxationAccountEdit/TaxationAccountEditBankSuccess";
// import TaxationAccountEditContact from "./containers/Accounts/TaxationAccount/TaxationAccountEdit/TaxationAccountEditContact";
// import TaxationEditAccountTaxType from "./containers/Accounts/TaxationAccount/TaxationAccountEdit/TaxationAccountEditTaxType";
// import TaxationAccountEditTaxSection from "./containers/Accounts/TaxationAccount/TaxationAccountEdit/TaxationAccountEditTaxSection";
// import TaxationEditAccountSuccess from "./containers/Accounts/TaxationAccount/TaxationAccountEdit/TaxationAccountEditSuccess";
// import TaxationAccountEditFailed from "./containers/Accounts/TaxationAccount/TaxationAccountEdit/TaxationAccountEditFailed";

// Tax transaction
// import TaxationTransactionDashboard from "./containers/Transactions/TaxationTransactions/TaxationTransactionDashboard";
// import TaxationTransactionCreate from "./containers/Transactions/TaxationTransactions/TaxationTransactionCreate";
// import TaxationTransactionSuccess from "./containers/Transactions/TaxationTransactions/TaxationTransactionSuccess";
// import TaxationTransactionFailed from "./containers/Transactions/TaxationTransactions/TaxationTransactionFailed";
// import TaxationTransactionViewAll from "./containers/Transactions/TaxationTransactions/TaxationTransactionViewAll";
// import TaxationTransactionDetails from "./containers/Transactions/TaxationTransactions/TaxationTransactionDetails";
// import TaxationTransactionSingleApproval from "./containers/Transactions/TaxationTransactions/TaxationTransactionSingleApproval";
// import TaxationMultiSelect from "./containers/Transactions/TaxationTransactions/TaxationTransactionMulti/TaxationMultiSelect";
// import TaxationMultiApproval from "./containers/Transactions/TaxationTransactions/TaxationTransactionMulti/TaxationMultiApproval";
// import TaxationMultiApprovalFailed from "./containers/Transactions/TaxationTransactions/TaxationTransactionMulti/TaxationMultiApprovalFailed";
// import TaxationMultiApprovalDeclined from "./containers/Transactions/TaxationTransactions/TaxationTransactionMulti/TaxationMultiApprovalDeclined";
// import TaxationMultiApprovalSuccess from "./containers/Transactions/TaxationTransactions/TaxationTransactionMulti/TaxationMultiApprovalSuccess";
// import TaxationTransactionUploadViewAll from "./containers/Transactions/TaxationTransactions/TaxationTransactionUploadViewAll";
// import TaxationTransactionUploadTDS from "./containers/Transactions/TaxationTransactions/TaxationTransactionUploadTDS";
// import TaxationTransactionUploadTDSSuccess from "./containers/Transactions/TaxationTransactions/TaxationTransactionUploadTDSSuccess";
// import TaxationTransactionUploadTDSFailed from "./containers/Transactions/TaxationTransactions/TaxationTransactionUploadTDSFailed";

// Field force account
import FieldForceAccountDashboard from "./containers/FieldForceAccount/FieldForceAccountDashboard";
import FieldForceAccountViewAll from "./containers/FieldForceAccount/FieldForceAccountViewAll";
import FieldForceAccountDetails from "./containers/FieldForceAccount/FieldForceAccountDetails";
import FieldForceAccountCreate from "./containers/FieldForceAccount/FieldForceAccountCreate";
import FieldForceAccountSingleAprroval from "./containers/FieldForceAccount/FieldForceAccountSingleAprroval";
import ReimbursementRequestMultiApproval from "./containers/ReimbursementRequest/ReimbursementRequestMultiApproval";
import ReimbursementRequestTxnMultiApprovalDetail from "./components/ReimbursementRequest/ReimbursementRequestMultiApproval/ ReimbursementRequestTxnMultiApprovalDetail";
import ReimbursementRequestMultiApprovalSuccess from "./components/ReimbursementRequest/ReimbursementRequestMultiApproval/ReimbursementRequestMultiApprovalSuccess";
import ReimbursementRequestMultiApprovalDeclined from "./components/ReimbursementRequest/ReimbursementRequestMultiApproval/ReimbursementRequestMultiApprovalDeclined";
import ReimbursementRequestMultiApprovalError from "./components/ReimbursementRequest/ReimbursementRequestMultiApproval/ReimbursementRequestMultiApprovalError";
import ReimbursementUnassignCategories from "./components/HomeDashboard/ReimbursementUnassignCategoriesMain/ReimbursementUnassignCategories";
import FieldForceTxnDashboard from "./containers/FieldForceTransactions/FieldForceTxnDashboard";
import FieldForceTransactionMultiApprovalDetail from "./components/FieldForceTransactionComp/FieldForceTransactionMultiApprovalDetail";
import FieldForceTransactionMultiApprovalSuccess from "./components/FieldForceTransactionComp/FieldForceTransactionMultiApprovalSuccess";
import FieldForceTransactionMultiApprovalError from "./components/FieldForceTransactionComp/FieldForceTransactionMultiApprovalError";
import FieldForceTransactionMultiApprovalDeclined from "./components/FieldForceTransactionComp/FieldForceTransactionMultiApprovalDeclined";
import MyProfileEditContactDetails from "./containers/Settings/MyProfileEditContactDetails";
import MyProfileContactDetailsSuccess from "./containers/Settings/MyProfileContactDetailsSuccess";
import UserEditContactError from "./containers/Settings/Users/UserEditContactError";

import FieldForceEditContact from "./containers/FieldForceAccount/FieldForceEditAccount/FieldForceEditContact";
import FieldForceContactSuccess from "./containers/FieldForceAccount/FieldForceEditAccount/FieldForceContactSuccess";
import FieldForceEditCategories from "./containers/FieldForceAccount/FieldForceEditAccount/FieldForceEditCategories";
import FieldForceCategoriesSuccess from "./containers/FieldForceAccount/FieldForceEditAccount/FieldForceCategoriesSuccess";
import FieldForceEditPan from "./containers/FieldForceAccount/FieldForceEditAccount/FieldForceEditPan";
import FieldForcePanEditSuccess from "./containers/FieldForceAccount/FieldForceEditAccount/FieldForcePanEditSuccess";
import FieldForceBankEditMain from "./containers/FieldForceAccount/FieldForceEditAccount/FieldForceMainEditBank";
import FieldForceBankEditSuccess from "./containers/FieldForceAccount/FieldForceEditAccount/FieldForceBankEditSuccess";
import FieldForceCreateTxn from "./containers/FieldForceTransactions/FieldForceCreateTxn";
import FieldForceTxnSingleApproval from "./containers/FieldForceTransactions/FieldForceTxnSingleApproval";
import CreateReimbursementAccount from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountCreate";
import FieldForceTxnRequestSingleApproval from "./containers/FieldForceRequestTransactions/FieldForceTxnRequestSingleApproval";
import FieldForceTxnRequestDetail from "./containers/FieldForceTransactions/FieldForceTxnRequestDetail";
import OwnerAccountConsolidatedLiveStatementComp from "./components/Accounts/OwnerAccount/OwnerAccountConsolidatedLiveStatementComp";
import FieldForceTxnRequestMultiApproval from "./containers/FieldForceRequestTransactions/FieldForceTxnRequestMultiApproval";
import FieldForceRequestCreateTransactions from "./containers/FieldForceRequestTransactions/FieldForceRequestCreateTransactions";
import FieldForceRequestTxnMultiApprovalDetail from "./components/FieldForceRequestTransactionComp/FieldForceRequestTxnMultiApprovalDetail";
import FieldForceRequestMultiApprovalSuccess from "./components/FieldForceRequestTransactionComp/FieldForceRequestMultiApprovalSuccess";
import FieldForceRequestMultiApprovalDeclined from "./components/FieldForceRequestTransactionComp/FieldForceRequestMultiApprovalDeclined";
import FieldForceRequestMultiApprovalError from "./components/FieldForceRequestTransactionComp/FieldForceRequestMultiApprovalError";
import FieldForceTransactionDetail from "./containers/FieldForceTransactions/FieldForceTransactionDetail";
import FieldForceTransactionViewAll from "./containers/FieldForceTransactions/FieldForceTransactionsViewAll";
import FieldForceAccountSuccess from "./containers/FieldForceAccount/FieldForceAccountSuccess";
import FieldForceAccountError from "./containers/FieldForceAccount/FieldForceAccountError";

// remitter account
import RemitterAccountDashboard from "./containers/Accounts/RemitterAccount/RemitterAccountDashboard";
import RemitterAccountCreate from "./containers/Accounts/RemitterAccount/RemitterAccountCreate";
import RemitterAccountSuccess from "./containers/Accounts/RemitterAccount/RemitterAccountSuccess";
import RemitterAccountFailed from "./containers/Accounts/RemitterAccount/RemitterAccountFailed";
import RemitterAccountViewAll from "./containers/Accounts/RemitterAccount/RemitterAccountViewAll";
import RemitterAccountDetails from "./containers/Accounts/RemitterAccount/RemitterAccountDetails";
import RemitterAccountApproval from "./containers/Accounts/RemitterAccount/RemitterAccountApproval";
import RemitterAccountEditName from "./containers/Accounts/RemitterAccount/RemitterAccountEdit/RemitterAccountEditName";
import RemitterAccountEditSuccess from "./containers/Accounts/RemitterAccount/RemitterAccountEdit/RemitterAccountEditNameSuccess";

import FieldForceTxnMultiApproval from "./containers/FieldForceTransactions/FieldForceTxnMultiApproval";
import FieldForceTxnSuccess from "./containers/FieldForceTransactions/FieldForceTxnSuccess";
import FieldForceTxnFailed from "./containers/FieldForceTransactions/FieldForceTxnFailed";
import FieldForceRequestCreateSucess from "./components/FieldForceRequestTransactionComp/FieldForceRequestCreateSucess";
import FieldForceRequestCreateError from "./components/FieldForceRequestTransactionComp/FieldForceRequestCreateError";
import FieldForceTxnRequestViewAll from "./containers/FieldForceRequestTransactions/FieldForceTxnRequestViewAll";

import ReimbursementEditPan from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountEdit/ReimbursementEditPan";
import ReimbursementPanEditSucess from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountEdit/ReimbursementPanEditSucess";
import ReimbursementCategories from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountEdit/ReimbursementCategories";
import ReimbursementCategoriesSucess from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountEdit/ReimbursementCategoriesSucess";
import ReimbursementEditContact from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountEdit/ReimbursementEditContact";
import ReimbursementContactSucess from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountEdit/ReimbursementContactSucess";
import ReimbursementEditBank from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountEdit/ReimbursementMainEditBank";
import ReimbursementBankEditSucess from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountEdit/ReimbursementBankEditSuccess";
import ReimbursementRecipient from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountEdit/ReimbursementRecipents";
import ReimbursementRecipentSucess from "./containers/Accounts/ReimbursementAccount/ReimbursementAccountEdit/ReimbursementRecipentSuccess";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="/" element={<LandingPageContainer />}>
        <Route path="/" element={<CheckUserLogin />}>
          <Route path="/" element={<LandingPage />} />
        </Route>
        <Route path="/amc" element={<CheckUserLogin />}>
          <Route path="/amc" element={<AMC />} />
        </Route>
        <Route path="/corporates" element={<CheckUserLogin />}>
          <Route path="/corporates" element={<Corporates />} />
        </Route>
        <Route path="/aboutus" element={<CheckUserLogin />}>
          <Route path="/aboutus" element={<AboutUs />} />
        </Route>
        <Route path="/advisors" element={<CheckUserLogin />}>
          <Route path="/advisors" element={<Advisors />} />
        </Route>
        <Route path="/book_demo" element={<CheckUserLogin />}>
          <Route path="/book_demo" element={<BookDemo />} />
        </Route>
        <Route path="/contactus" element={<CheckUserLogin />}>
          <Route path="/contactus" element={<ContactUs />} />
        </Route>
        <Route path="/product" element={<CheckUserLogin />}>
          <Route path="/product" element={<Product />} />
        </Route>

        <Route path="/pricing" element={<CheckUserLogin />}>
          <Route path="/pricing" element={<Pricing />} />
        </Route>

        <Route path="/bank_statement" element={<CheckUserLogin />}>
          <Route path="/bank_statement" element={<BankStatement />} />
        </Route>
        <Route path="/view_all_balances" element={<CheckUserLogin />}>
          <Route path="/view_all_balances" element={<ViewAllBalances />} />
        </Route>
        <Route path="/privacy_policy" element={<CheckUserLogin />}>
          <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        </Route>
        <Route path="/terms_conditions" element={<CheckUserLogin />}>
          <Route path="/terms_conditions" element={<TermsConditions />} />
        </Route>
      </Route>
      {/* login start */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/LoginTotp" element={<LoginTotp />} />

      <Route
        path="/relogin"
        element={
          <RequireAuth>
            <Relogin />
          </RequireAuth>
        }
      />
      <Route
        path="/setNewPassword"
        element={
          <RequireAuth>
            <SetNewPassword />
          </RequireAuth>
        }
      />
      <Route path="/contactAdmin" element={<ContactAdmin />} />
      {/* login end */}
      <Route
        path="/"
        element={
          <RequireAuth>
            <AppBar />
          </RequireAuth>
        }
      >
        {/* multi entity start */}
        <Route path="/multi_entity" element={<MultiEntities />} />
        <Route path="/multi_entity_viewAll" element={<MultiEntityViewAll />} />
        {/* multi entity start */}
        {/* home Dashobard start */}
        <Route path="/home" element={<HomeDashboard />} />
        <Route
          path="/home/unassign_multi_categories"
          element={<UnassignCategories />}
        />
        <Route
          path="/home/unassign_reimbursement_categories"
          element={<ReimbursementUnassignCategories />}
        />
        <Route
          path="/home/unassign_field_force_categories"
          element={<FieldForceUnassignCategories />}
        />
        <Route
          path="/home/reminders"
          element={
            <FeatureNotAssign userServices={("AReminder", "VReminder")} />
          }
        >
          <Route path="/home/reminders" element={<ReminderTransaction />} />
        </Route>
        <Route path="/home/profile_quick_menu" element={<ProfileQuickMenu />} />
        
        <Route
          path="/my_profile"
          element={<FeatureNotAssign userServices={"VSpecificEmp"} />}
        >
          <Route path="/my_profile" element={<MyProfileDetails />} />
        </Route>
        {/* <Route
          path="/settings/my_profile/contact_details/:id"
          element={<MyProfileEditContactDetails />}
        /> */}
        <Route
          path="/settings/my_profile/contact_details/:id"
          element={<MyProfileEditContactDetails />}
        />
        <Route
          path="/settings/my_profile/contact_details_success/:id"
          element={<MyProfileContactDetailsSuccess />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/create_reimbursement_request"
          element={<FeatureNotAssign userServices={"CReimbursementTxn"} />}
        >
          <Route
            path="/reimbursement_transaction_dashboard/create_reimbursement_request"
            element={<ReimbursementTxnRequestCreate />}
          />
        </Route>
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_request_view_all"
          element={<FeatureNotAssign userServices={"VReimbursementTxn"} />}
        >
          <Route
            path="/reimbursement_transaction_dashboard/reimbursement_request_view_all"
            element={<ReimbursementRequestViewAll />}
          />
        </Route>
        <Route
          path="/reimbursement_transaction_dashboard/create_reimbursement_transactions/success/:id"
          element={<ReimbursementSuccessPage />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/create_reimbursement_transactions/failed"
          element={<ReimbursementRequestFailure />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/create_reimbursement_transactions_txn/success/:id"
          element={<ReimbursementTxnSuccessPage />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/create_reimbursement_transactions_txn/failed"
          element={<ReimbursementTxnErrorPage />}
        />
        {/* home Dashobard end */}
        {/* beneficiary transaction  start */}
        <Route
          path="/beneficiary_transaction_dashboard"
          element={<FeatureNotAssign userServices={"VBeneficiaryTxn"} />}
        >
          <Route
            path="/beneficiary_transaction_dashboard"
            element={<BeneficiaryTransactionDashboard />}
          />
        </Route>
        <Route
          path="/beneficiary_transaction_dashboard/create_beneficiary_transaction"
          element={<FeatureNotAssign userServices={"CBeneficiaryTxn"} />}
        >
          <Route
            path="/beneficiary_transaction_dashboard/create_beneficiary_transaction"
            element={<BeneficiaryTransactionCreate />}
          />
        </Route>
        <Route
          path="/beneficiary_transaction_dashboard/create_beneficiary_transaction/success/:id"
          element={<BeneficiaryTransactionSuccess />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/create_beneficiary_transaction/failed"
          element={<BeneficiaryTransactionFailed />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/beneficiary_transaction_view_all"
          element={
            <FeatureNotAssign
              userServices={"VBeneficiaryTxn,VAccountBalance,VConfidentialTxn"}
            />
          }
        >
          <Route
            path="/beneficiary_transaction_dashboard/beneficiary_transaction_view_all"
            element={<BeneficiaryTransactionViewall />}
          />
        </Route>
        <Route
          path="/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/:id"
          element={<BeneficiaryTransactionDetails />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/beneficiary_transaction_single_approval"
          element={<FeatureNotAssign userServices={"ABeneficiaryTxn"} />}
        >
          <Route
            path="/beneficiary_transaction_dashboard/beneficiary_transaction_single_approval"
            element={<BeneficiaryTransactionSingleApproval />}
          />
        </Route>
        <Route
          path="/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval"
          element={<FeatureNotAssign userServices={"ABeneficiaryTxn"} />}
        >
          <Route
            path="/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval"
            element={<BeneficiaryTransactionMultiSelect />}
          />
        </Route>
        <Route
          path="/beneficiary_transaction_dashboard/multi_select/multi_approval/declined"
          element={<BeneficiaryMultiApprovalDeclined />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval/multi_approval"
          element={<BeneficiaryMultiApproval />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval/multi_approval/error"
          element={<BeneficiaryMultiApprovalFailed />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval/multi_approval/declined"
          element={<BeneficiaryMultiApprovalDeclined />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval/multi_approval/success"
          element={<BeneficiaryMultiApprovalSuccess />}
        />
        {/* bulk transaction start  */}
        <Route
          path="/beneficiary_transaction_dashboard/create_bulk_transaction"
          element={<FeatureNotAssign userServices={"CTransactionUpload"} />}
        >
          <Route
            path="/beneficiary_transaction_dashboard/create_bulk_transaction"
            element={<BulkTrasanctionCreate />}
          />
        </Route>
        <Route
          path="/beneficiary_transaction_dashboard/create_bulk_transaction/success"
          element={<BulkTransactionSuccess />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/create_bulk_transaction/error"
          element={<BulkTransactionFailed />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/bulk_transaction_view_all"
          element={<FeatureNotAssign userServices={"VTransactionUpload"} />}
        >
          <Route
            path="/beneficiary_transaction_dashboard/bulk_transaction_view_all"
            element={<BulkTransactionViewAll />}
          />
        </Route>
        <Route
          path="/beneficiary_transaction_dashboard/bulk_transaction_view_all/bulk_transaction_detail_page/:id"
          element={<BulkTransactionDetails />}
        />
        {/* bulk transaction end  */}
        {/* beneficiary transaction  end */}
        {/* Recreate transaction start  */}
        <Route
          path="/beneficiary_transaction_dashboard/recreate_beneficiary_transaction_dashboard"
          element={<FeatureNotAssign userServices={"VBeneficiaryTxn"} />}
        >
          <Route
            path="/beneficiary_transaction_dashboard/recreate_beneficiary_transaction_dashboard"
            element={<BeneficiaryTransactionRecreateDashboard />}
          />
        </Route>
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/:id"
          element={<FeatureNotAssign userServices={"VReimbursementTxn"} />}
        >
          <Route
            path="/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/:id"
            element={<ReimbursementTxnRequestDetail />}
          />
        </Route>
        {/* Reimbursement transaction  end */}
        {/* Reimbursement transaction  start */}
        <Route
          path="/reimbursement_transaction_dashboard"
          element={<FeatureNotAssign userServices={"VReimbursementTxn"} />}
        >
          <Route
            path="/reimbursement_transaction_dashboard"
            element={<ReimbursementTransactionDashboard />}
          />
        </Route>
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_transaction_view_all"
          element={<FeatureNotAssign userServices={"VReimbursementTxn"} />}
        >
          <Route
            path="/reimbursement_transaction_dashboard/reimbursement_transaction_view_all"
            element={<ReimbursementTransactionViewAll flow={"view_all"} />}
          />
        </Route>
        {/* Reimbursement transaction  end */}
        {/* beneficiary schedule transaction  start */}
        <Route
          path="/beneficiary_transaction_dashboard/create_schedule"
          element={<FeatureNotAssign userServices={"BCScheduledTxn"} />}
        >
          <Route
            path="/beneficiary_transaction_dashboard/create_schedule"
            element={<ScheduleBeneficiaryTransactionCreate />}
          />
        </Route>
        <Route
          path="/beneficiary_transaction_dashboard/create_schedule/success/:id"
          element={<ScheduleBeneficiaryTransactionSuccess />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/create_schedule/failed"
          element={<ScheduleBeneficiaryTransactionFailed />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/schedule_view_all"
          element={<FeatureNotAssign userServices={"BVScheduledTxn"} />}
        >
          <Route
            path="/beneficiary_transaction_dashboard/schedule_view_all"
            element={<ScheduleBeneficiaryTransactionViewSchedules />}
          />
          <Route
            path="/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/:id"
            element={<ScheduleBeneficiaryTransactionDetails />}
          />
        </Route>
        <Route
          path="/beneficiary_transaction_dashboard/schedule_single_approval"
          element={<FeatureNotAssign userServices={"BAScheduledTxn"} />}
        >
          <Route
            path="/beneficiary_transaction_dashboard/schedule_single_approval"
            element={<ScheduleBeneficiaryTransactionSingleApproval />}
          />
        </Route>
        <Route
          path="/beneficiary_transaction_dashboard/schedule_multi_approval"
          element={<FeatureNotAssign userServices={"BAScheduledTxn"} />}
        >
          <Route
            path="/beneficiary_transaction_dashboard/schedule_multi_approval"
            element={<ScheduleBeneficiaryMultiSelect />}
          />
          <Route
            path="/beneficiary_transaction_dashboard/schedule_multi_approval/schedules_multi_approval"
            element={<ScheduleBeneficiaryMultiApproval />}
          />
        </Route>
        <Route
          path="/beneficiary_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_success"
          element={<ScheduleBeneficiaryMultiApprovalSuccess />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_declined"
          element={<ScheduleBeneficiaryMultiApprovalDeclined />}
        />
        <Route
          path="/beneficiary_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_error"
          element={<ScheduleBeneficiaryMultiApprovalFailed />}
        />
        {/* beneficiary schedule transaction end */}
        <Route
          path="/reimbursement_transaction_dashboard/create_reimbursement_transactions"
          element={
            <FeatureNotAssign
              userServices={"AReimbursementRequest, CReimbursementTxn"}
            />
          }
        >
          <Route
            path="/reimbursement_transaction_dashboard/create_reimbursement_transactions"
            element={<ReimburseCreateTxn />}
          />
        </Route>
        {/* internal transaction start */}
        <Route
          path="/internal_transaction_dashboard"
          element={<FeatureNotAssign userServices={"VInternalTxn"} />}
        >
          <Route
            path="/internal_transaction_dashboard"
            element={<InternalTransactionDashboard />}
          />
          <Route
            path="/internal_transaction_dashboard/internal_transaction_view_all"
            element={<InternalTransactionViewAll />}
          />
          <Route
            path="/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/:id"
            element={<InternalTransactionDetails />}
          />
        </Route>
        <Route
          path="/internal_transaction_dashboard/create_internal_transaction"
          element={<FeatureNotAssign userServices={"CInternalTxn"} />}
        >
          <Route
            path="/internal_transaction_dashboard/create_internal_transaction"
            element={<InternalTransactionCreate />}
          />
        </Route>
        <Route
          path="/internal_transaction_dashboard/create_internal_transaction/success/:id"
          element={<InternalTransactionSuccess />}
        />
        <Route
          path="/internal_transaction_dashboard/create_internal_transaction/failed"
          element={<InternalTransactionFailed />}
        />
        <Route
          path="/internal_transaction_dashboard/internal_transaction_single_approval"
          element={<FeatureNotAssign userServices={"AInternalTxn"} />}
        >
          <Route
            path="/internal_transaction_dashboard/internal_transaction_single_approval"
            element={<InternalTransactionSingleApproval />}
          />
        </Route>
        <Route
          path="/internal_transaction_dashboard/internal_transaction_multi_approval"
          element={<FeatureNotAssign userServices={"AInternalTxn"} />}
        >
          <Route
            path="/internal_transaction_dashboard/internal_transaction_multi_approval"
            element={<InternalTransactionMultiSelect />}
          />
        </Route>
        <Route
          path="/internal_transaction_dashboard/internal_transaction_multi_approval/multi_approval"
          element={<FeatureNotAssign userServices={"AInternalTxn"} />}
        >
          <Route
            path="/internal_transaction_dashboard/internal_transaction_multi_approval/multi_approval"
            element={<InternalMultiApproval />}
          />
        </Route>
        <Route
          path="/internal_transaction_dashboard/internal_transaction_multi_approval/multi_approval/success"
          element={<InternalMultiApprovalSuccess />}
        />
        <Route
          path="/internal_transaction_dashboard/internal_transaction_multi_approval/multi_approval/error"
          element={<InternalMultiApprovalFailed />}
        />
        <Route
          path="/internal_transaction_dashboard/internal_transaction_multi_approval/multi_approval/declined"
          element={<InternalMultiApprovalDeclined />}
        />
        {/* internal transaction end */}
        {/* recreate transaction start */}
        <Route
          path="/internal_transaction_dashboard/recreate_internal_transaction_dashboard"
          element={<FeatureNotAssign userServices={"VInternalTxn"} />}
        >
          <Route
            path="/internal_transaction_dashboard/recreate_internal_transaction_dashboard"
            element={<InternalTransactionRecreateDashboard />}
          />
        </Route>
        {/* internal transaction end */}
        {/* internal schedule transaction start */}
        <Route
          path="/internal_transaction_dashboard/create_schedule_transaction"
          element={<FeatureNotAssign userServices={"ICScheduledTxn"} />}
        >
          <Route
            path="/internal_transaction_dashboard/create_schedule_transaction"
            element={<ScheduleInternalTransactionCreate />}
          />
        </Route>
        <Route
          path="/internal_transaction_dashboard/create_schedule_transaction/success/:id"
          element={<ScheduleInternalTransactionSuccess />}
        />
        <Route
          path="/internal_transaction_dashboard/create_schedule_transaction/failed"
          element={<ScheduleInternalTransactionFailed />}
        />
        <Route
          path="/internal_transaction_dashboard/schedule_view_all"
          element={<FeatureNotAssign userServices={"IVScheduledTxn"} />}
        >
          <Route
            path="/internal_transaction_dashboard/schedule_view_all"
            element={<ScheduleInternalTransactionViewSchedules />}
          />
          <Route
            path="/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/:id"
            element={<ScheduleInternalTransactionDetails />}
          />
        </Route>
        <Route
          path="/internal_transaction_dashboard/schedule_single_approval"
          element={<FeatureNotAssign userServices={"IAScheduledTxn"} />}
        >
          <Route
            path="/internal_transaction_dashboard/schedule_single_approval"
            element={<ScheduleInternalTransactionSingleApproval />}
          />
        </Route>
        <Route
          path="/internal_transaction_dashboard/schedule_multi_approval"
          element={<FeatureNotAssign userServices={"IAScheduledTxn"} />}
        >
          <Route
            path="/internal_transaction_dashboard/schedule_multi_approval"
            element={<ScheduleInternalTransactionMultiSelect />}
          />
          <Route
            path="/internal_transaction_dashboard/schedule_multi_approval/schedules_multi_approval"
            element={<ScheduleInternalMultiApproval />}
          />
        </Route>
        <Route
          path="/internal_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_success"
          element={<ScheduleInternalMultiApprovalSuccess />}
        />
        <Route
          path="/internal_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_reject"
          element={<ScheduleInternalMultiApprovalDeclined />}
        />
        <Route
          path="/internal_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_error"
          element={<ScheduleInternalMultiApprovalFailed />}
        />
        {/* internal schedule transaction end */}
        {/*  beneficiary account start */}
        <Route
          path="/beneficiary_account_dashboard"
          element={<FeatureNotAssign userServices={"BVAccount"} />}
        >
          <Route
            path="/beneficiary_account_dashboard"
            element={<BeneficiaryAccountDashboard />}
          />
        </Route>
        <Route
          path="/beneficiary_account_dashboard/create_beneficiary_account"
          element={<FeatureNotAssign userServices={"BUAccount"} />}
        >
          <Route
            path="/beneficiary_account_dashboard/create_beneficiary_account"
            element={<BeneficiaryAccountCreate />}
          />
        </Route>
        <Route
          path="/beneficiary_account_dashboard/create_beneficiary_account/success/:id"
          element={<BeneficiaryAccountSuccess />}
        />
        <Route
          path="/beneficiary_account_dashboard/create_beneficiary_account/failed"
          element={<BeneficiaryAccountFailed />}
        />
        <Route
          path="/beneficiary_account_dashboard/beneficiary_account_view_all"
          element={<FeatureNotAssign userServices={"BVAccount"} />}
        >
          <Route
            path="/beneficiary_account_dashboard/beneficiary_account_view_all"
            element={<BeneficiaryAccountViewAll />}
          />
        </Route>
        <Route
          path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/:id"
          element={<BeneficiaryAccountDetails />}
        />
        <Route
          path="/beneficiary_account_dashboard/beneficiary_account_approval"
          element={<FeatureNotAssign userServices={"BAAccount"} />}
        >
          <Route
            path="/beneficiary_account_dashboard/beneficiary_account_approval"
            element={<BeneficiaryAcountApproval />}
          />
        </Route>
        {/*  beneficiary account end */}
        {/* beneficiary account edit start */}
        <Route
          path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_bank_details/:id"
          element={<FeatureNotAssign userServices={"BUAccount"} />}
        >
          <Route
            path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_bank_details/:id"
            element={<BeneficiaryAccountEditBank />}
          />
        </Route>
        <Route
          path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_PAN_details/:id"
          element={<FeatureNotAssign userServices={"BUAccount"} />}
        >
          <Route
            path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_PAN_details/:id"
            element={<BeneficiaryAccountEditPAN />}
          />
        </Route>
        <Route
          path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_account_details/:id"
          element={<FeatureNotAssign userServices={"BUAccount"} />}
        >
          <Route
            path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_account_details/:id"
            element={<BeneficiaryAccountEditContact />}
          />
        </Route>
        <Route
          path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_categories/:id"
          element={<FeatureNotAssign userServices={"BUAccount"} />}
        >
          <Route
            path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_categories/:id"
            element={<BeneficiaryAccountEditCategories />}
          />
        </Route>
        <Route
          path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/bank_edit_success/:id"
          element={<BeneficiaryAccountEditBankSuccess />}
        />
        <Route
          path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/pan_edit_success/:id"
          element={<BeneficiaryAccountEditPANSuccess />}
        />
        <Route
          path="/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/:successType/:id"
          element={<BeneficiaryAccountEditSuccess />}
        />
        {/*  beneficiary account edit end */}
        {/* Reimbursement Acc start */}
        <Route
          path="/reimbursement_account_dashboard"
          element={<FeatureNotAssign userServices={"RVAccount"} />}
        >
          <Route
            path="/reimbursement_account_dashboard"
            element={<ReimbursementDashboard />}
          />
        </Route>
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_approval"
          element={<FeatureNotAssign userServices={"RAAccount"} />}
        >
          <Route
            path="/reimbursement_account_dashboard/reimbursement_account_approval"
            element={<ReimbursementAccountApproval />}
          />
        </Route>
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all"
          element={<FeatureNotAssign userServices={"RVAccount"} />}
        >
          <Route
            path="/reimbursement_account_dashboard/reimbursement_account_view_all"
            element={<ReimbursementAccountViewAll />}
          />
        </Route>
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/:id"
          element={<ReimbursementAccountDetails />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_request_single_approval"
          element={<FeatureNotAssign userServices={"AReimbursementRequest"} />}
        >
          <Route
            path="/reimbursement_transaction_dashboard/reimbursement_request_single_approval"
            element={<ReimbursementRequestSingleApproval />}
          />
        </Route>
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_request_multi_select"
          element={<ReimbursementRequestMultiApproval />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_request_multi_select/reimbursement_request_multi_approval"
          element={<ReimbursementRequestTxnMultiApprovalDetail />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_request_multi_select/reimbursement_request_multi_approval/request_multi_transaction_success"
          element={<ReimbursementRequestMultiApprovalSuccess />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_request_multi_select/reimbursement_request_multi_approval/request_multi_transaction_declined"
          element={<ReimbursementRequestMultiApprovalDeclined />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_request_multi_select/reimbursement_request_multi_approval/request_multi_transaction_error"
          element={<ReimbursementRequestMultiApprovalError />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_transaction_single_approval"
          element={<FeatureNotAssign userServices={"AReimbursementTxn"} />}
        >
          <Route
            path="/reimbursement_transaction_dashboard/reimbursement_transaction_single_approval"
            element={<ReimbursementTxnSingleApproval />}
          />
        </Route>
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_transaction_multi_approval"
          element={<ReimbursementTxnMultiApproval />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_transaction_multi_approval/multi_approval"
          element={<ReimbursementTxnMultiApprovalDetail />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/multi_approval/reimbursement_multi_transaction_success"
          element={<ReimbursementTxnMultiApprovalSuccess />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/multi_approval/reimbursement_multi_transaction_declined"
          element={<ReimbursementTxnMultiApprovalDeclined />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/multi_approval/reimbursement_multi_transaction_error"
          element={<ReimbursementTxnMultiApprovalError />}
        />
        <Route
          path="/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/:id"
          element={<ReimbursementTxnDetails />}
        />
        <Route
          path="/reimbursement_account_dashboard/create_reimbursement_account"
          element={<FeatureNotAssign userServices={"RUAccount"} />}
        >
          <Route
            path="/reimbursement_account_dashboard/create_reimbursement_account"
            element={<CreateReimbursementAccount />}
          />
        </Route>
        <Route
          path="/reimbursement_account_dashboard/create_reimbursement_account/success/:id"
          element={<CreateSuccess />}
        />
        <Route
          path="/reimbursement_account_dashboard/create_reimbursement_account/error"
          element={<ReimbursementAccountCreateError />}
        />
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/categories_edit_success/:id"
          element={<ReimbursementCategoriesSucess />}
        />
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_PAN_details/:id"
          element={<FeatureNotAssign userServices={"RUAccount"} />}
        >
          <Route
            path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_PAN_details/:id"
            element={<ReimbursementEditPan />}
          />
        </Route>
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_categories/:id"
          element={<FeatureNotAssign userServices={"RUAccount"} />}
        >
          {" "}
          <Route
            path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_categories/:id"
            element={<ReimbursementCategories />}
          />
        </Route>
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_recipient/:id"
          element={<FeatureNotAssign userServices={"RUAccount"} />}
        >
          {" "}
          <Route
            path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_recipient/:id"
            element={<ReimbursementRecipient />}
          />
        </Route>
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/recipients_edit_success/:id"
          element={<ReimbursementRecipentSucess />}
        />
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_account_detail/:id"
          element={<FeatureNotAssign userServices={"RUAccount"} />}
        >
          {" "}
          <Route
            path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_account_detail/:id"
            element={<ReimbursementEditContact />}
          />
        </Route>
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/pan_edit_success/:id"
          element={<ReimbursementPanEditSucess />}
        />
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all/view_details/Contact_edit_success/:id"
          element={<ReimbursementContactSucess />}
        />
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_bank_details/:id"
          element={<FeatureNotAssign userServices={"RUAccount"} />}
        >
          <Route
            path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_bank_details/:id"
            element={<ReimbursementEditBank />}
          />
        </Route>
        <Route
          path="/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/bank_edit_success/:id"
          element={<ReimbursementBankEditSucess />}
        />
        {/* Reimbursement account end */}
        {/*  internal account start */}
        <Route
          path="/internal_account_dashboard"
          element={<FeatureNotAssign userServices={"IVAccount"} />}
        >
          <Route
            path="/internal_account_dashboard"
            element={<InternalAccountDashboard />}
          />
          <Route
            path="/internal_account_dashboard/internal_account_view_all"
            element={<FeatureNotAssign userServices={"IVAccount"} />}
          >
            <Route
              path="/internal_account_dashboard/internal_account_view_all"
              element={<InternalAccountViewAll />}
            />
          </Route>
          <Route
            path="/internal_account_dashboard/internal_account_approval"
            element={<FeatureNotAssign userServices={"IAAccount"} />}
          >
            <Route
              path="/internal_account_dashboard/internal_account_approval"
              element={<InternalAccountApproval />}
            />
          </Route>
          <Route
            path="/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/:id"
            element={<InternalAccountDetails />}
          />
          <Route
            path="/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/edit_account_details/:id"
            element={<InternalAccountEditContact />}
          />
        </Route>
        <Route
          path="/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/edit_contact_success/:id"
          element={<InternalAccountEditSuccess />}
        />
        {/*  internal account end */}
        {/*  owner account start */}
        <Route
          path="/owner_account_dashboard"
          element={<OwnerAccountDashboard />}
        />
        <Route
          path="/owner_account_dashboard/owner_accounts_view_all"
          element={<FeatureNotAssign userServices={"VAccount"} />}
        >
          <Route
            path="/owner_account_dashboard/owner_accounts_view_all"
            element={<OwnerAccountViewAll />}
          />
        </Route>
        <Route
          path="/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/:id"
          element={<OwnerAccountDetails />}
        />
        <Route
          path="/owner_account_dashboard/upload_bulk_bank_statement"
          element={<FeatureNotAssign userServices={"CStatementUpload"} />}
        >
          <Route
            path="/owner_account_dashboard/upload_bulk_bank_statement"
            element={<OwnerAccountBulkUploadStatement />}
          />
        </Route>
        <Route
          path="/owner_account_dashboard/upload_bulk_bank_statement/success"
          element={<OwnerAccountBulkUploadStatementSuccess />}
        />
        <Route
          path="/owner_account_dashboard/consolidated_bank_statement"
          element={<FeatureNotAssign userServices={"VAccountBalance,Admin"} />}
        >
          <Route
            path="/owner_account_dashboard/consolidated_bank_statement"
            element={<OwnerAccountConsolidatedBankStatement />}
          />
        </Route>
        <Route
          path="/owner_account_dashboard/consolidated_live_statement"
          element={
            <FeatureNotAssign userServices={"VItemisedStatement,Admin"} />
          }
        >
          <Route
            path="/owner_account_dashboard/consolidated_live_statement"
            element={<OwnerAccountConsolidatedLiveStatementComp />}
          />
        </Route>
        {/*  owner account end */}
        {/*  remitter account start */}
        <Route
          path="/remitter_account_dashboard"
          element={<FeatureNotAssign userServices={"REVAccount"} />}
        >
          <Route
            path="/remitter_account_dashboard"
            element={<RemitterAccountDashboard />}
          />
        </Route>
        <Route
          path="/remitter_account_dashboard/create_remitter_account"
          element={<FeatureNotAssign userServices={"REUAccount"} />}
        >
          <Route
            path="/remitter_account_dashboard/create_remitter_account"
            element={<RemitterAccountCreate />}
          />
        </Route>
        <Route
          path="/remitter_account_dashboard/create_remitter_account/success/:id"
          element={<RemitterAccountSuccess />}
        />
        <Route
          path="/remitter_account_dashboard/create_remitter_account/failed"
          element={<RemitterAccountFailed />}
        />
        <Route
          path="/remitter_account_dashboard/remitter_account_view_all"
          element={<FeatureNotAssign userServices={"REVAccount"} />}
        >
          <Route
            path="/remitter_account_dashboard/remitter_account_view_all"
            element={<RemitterAccountViewAll />}
          />
        </Route>
        <Route
          path="/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/:id"
          element={<RemitterAccountDetails />}
        />
        <Route
          path="/remitter_account_dashboard/remitter_account_approval"
          element={<FeatureNotAssign userServices={"REAAccount"} />}
        >
          <Route
            path="/remitter_account_dashboard/remitter_account_approval"
            element={<RemitterAccountApproval />}
          />
        </Route>
        <Route
          path="/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/edit_account_details/:id"
          element={<FeatureNotAssign userServices={"REUAccount"} />}
        >
          <Route
            path="/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/edit_account_details/:id"
            element={<RemitterAccountEditName />}
          />
        </Route>
        <Route
          path="/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/success/:id"
          element={<RemitterAccountEditSuccess />}
        />
        {/*  remitter account end */}
        {/*  settings start */}
        <Route path="/settings" element={<SettingsDashboard />} />
        <Route path="/settings/statistics" element={<Statistics />} />
        <Route path="/settings/role_view_all" element={<Roles />} />
        <Route
          path="/settings/feature_view_all"
          element={<FeaturesViewAll />}
        />
        <Route
          path="/settings/service_view_all"
          element={<ServicesViewAll />}
        />
        <Route path="/settings/user_view_all" element={<UsersSettings />} />
        <Route
          path="/field_force_account_dashboard"
          element={<FeatureNotAssign userServices={"FFVAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard"
            element={<FieldForceAccountDashboard />}
          />
        </Route>
        <Route
          path="/field_force_account_dashboard/field_force_account_view_all"
          element={<FeatureNotAssign userServices={"FFVAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard/field_force_account_view_all"
            element={<FieldForceAccountViewAll />}
          />
        </Route>
        <Route
          path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/:id"
          element={<FieldForceAccountDetails />}
        />
        <Route
          path="/field_force_account_dashboard/create_field_force_account/success/:id"
          element={<FieldForceAccountSuccess />}
        />
        <Route
          path="/field_force_account_dashboard/create_field_force_account/error"
          element={<FieldForceAccountError />}
        />
        <Route
          path="/field_force_account_dashboard/create_field_force_account"
          element={<FeatureNotAssign userServices={"FFUAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard/create_field_force_account"
            element={<FieldForceAccountCreate />}
          />
        </Route>
        <Route
          path="/field_force_account_dashboard/field_force_account_approval"
          element={<FeatureNotAssign userServices={"FFAAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard/field_force_account_approval"
            element={<FieldForceAccountSingleAprroval />}
          />
        </Route>
        <Route
          path="/field_force_transaction_dashboard/field_force_transaction_single_approval"
          element={<FeatureNotAssign userServices={"AFieldForceTxn"} />}
        >
          <Route
            path="/field_force_transaction_dashboard/field_force_transaction_single_approval"
            element={<FieldForceTxnSingleApproval />}
          />
        </Route>
        <Route
          path="/field_force_transaction_dashboard/field_force_transaction_multi_approval"
          element={<FeatureNotAssign userServices={"AFieldForceTxn"} />}
        >
          <Route
            path="/field_force_transaction_dashboard/field_force_transaction_multi_approval"
            element={<FieldForceTxnMultiApproval />}
          />
        </Route>
        <Route
          path="/field_force_transaction_dashboard/create_field_force_transaction"
          element={<FeatureNotAssign userServices={"CFieldForceTxn"} />}
        >
          <Route
            path="/field_force_transaction_dashboard/create_field_force_transaction"
            element={<FieldForceCreateTxn />}
          />
        </Route>
        <Route
          path="/field_force_transaction_dashboard/create_field_force_transaction/success/:id"
          element={<FieldForceTxnSuccess />}
        />
        <Route
          path="/field_force_transaction_dashboard/create_field_force_transaction/failed"
          element={<FieldForceTxnFailed />}
        />
        <Route
          path="/field_force_transaction_dashboard"
          element={<FeatureNotAssign userServices={"VFieldForceTxn"} />}
        >
          <Route
            path="/field_force_transaction_dashboard"
            element={<FieldForceTxnDashboard />}
          />
        </Route>
        <Route
          path="/field_force_transaction_dashboard/field_force_transaction_view_all"
          element={<FeatureNotAssign userServices={"VFieldForceTxn"} />}
        >
          <Route
            path="/field_force_transaction_dashboard/field_force_transaction_view_all"
            element={<FieldForceTransactionViewAll />}
          />
        </Route>
        <Route
          path="/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/:id"
          element={<FieldForceTransactionDetail />}
        />
        <Route
          path="/field_force_transaction_dashboard/field_force_transaction_multi_approval/multi_approval"
          element={<FieldForceTransactionMultiApprovalDetail />}
        />
        <Route
          path="/field_force_transaction_dashboard/multi_approval/success"
          element={<FieldForceTransactionMultiApprovalSuccess />}
        />
        <Route
          path="/field_force_transaction_dashboard/multi_approval/error"
          element={<FieldForceTransactionMultiApprovalError />}
        />
        <Route
          path="/field_force_transaction_dashboard/multi_approval/field_force_multi_transaction_declined"
          element={<FieldForceTransactionMultiApprovalDeclined />}
        />
        <Route
          path="/field_force_transaction_dashboard/create_field_force_request"
          element={<FeatureNotAssign userServices={"CFieldForceTxn"} />}
        >
          <Route
            path="/field_force_transaction_dashboard/create_field_force_request"
            element={<FieldForceRequestCreateTransactions />}
          />
        </Route>
        <Route
          path="/field_force_transaction_dashboard/create_field_force_request/success/:id"
          element={<FieldForceRequestCreateSucess />}
        />
        <Route
          path="/field_force_transaction_dashboard/create_field_force_request/failed"
          element={<FieldForceRequestCreateError />}
        />
        <Route
          path="/field_force_transaction_dashboard/field_force_request_single_approval"
          element={<FeatureNotAssign userServices={"AFieldForceRequest"} />}
        >
          <Route
            path="/field_force_transaction_dashboard/field_force_request_single_approval"
            element={<FieldForceTxnRequestSingleApproval />}
          />
        </Route>
        <Route
          path="/field_force_transaction_dashboard/field_force_request_multi_approval"
          element={<FieldForceTxnRequestMultiApproval />}
        />
        <Route
          path="/field_force_transaction_dashboard/field_force_request_multi_approval/multi_approval"
          element={<FieldForceRequestTxnMultiApprovalDetail />}
        />
        <Route
          path="/field_force_transaction_dashboard/field_force_request_multi_approval/multi_approval/request_multi_transaction_success"
          element={<FieldForceRequestMultiApprovalSuccess />}
        />
        <Route
          path="/field_force_transaction_dashboard/field_force_request_multi_approval/multi_approval/request_multi_transaction_declined"
          element={<FieldForceRequestMultiApprovalDeclined />}
        />
        <Route
          path="/field_force_transaction_dashboard/field_force_request_multi_approval/multi_approval/request_multi_transaction_error"
          element={<FieldForceRequestMultiApprovalError />}
        />
        <Route
          path="/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/:id"
          element={<FeatureNotAssign userServices={"VFieldForceTxn"} />}
        >
          <Route
            path="/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/:id"
            element={<FieldForceTxnRequestDetail />}
          />
        </Route>
        <Route
          path="/field_force_transaction_dashboard/field_force_request_view_all"
          element={<FieldForceTxnRequestViewAll />}
        />
        <Route
          path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/account_details/:id"
          element={<FeatureNotAssign userServices={"FFUAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/account_details/:id"
            element={<FieldForceEditContact />}
          />
        </Route>
        <Route
          path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/account_details_success/:id"
          element={<FeatureNotAssign userServices={"FFUAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/account_details_success/:id"
            element={<FieldForceContactSuccess />}
          />
        </Route>
        <Route
          path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_categories/:id"
          element={<FeatureNotAssign userServices={"FFUAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_categories/:id"
            element={<FieldForceEditCategories />}
          />
        </Route>
        <Route
          path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_categories_success/:id"
          element={<FeatureNotAssign userServices={"FFUAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_categories_success/:id"
            element={<FieldForceCategoriesSuccess />}
          />
        </Route>
        <Route
          path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_PAN_details/:id"
          element={<FeatureNotAssign userServices={"FFUAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_PAN_details/:id"
            element={<FieldForceEditPan />}
          />
        </Route>
        <Route
          path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_PAN_details_success/:id"
          element={<FeatureNotAssign userServices={"FFUAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_PAN_details_success/:id"
            element={<FieldForcePanEditSuccess />}
          />
        </Route>
        <Route
          path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_bank_details/:id"
          element={<FeatureNotAssign userServices={"FFUAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_bank_details/:id"
            element={<FieldForceBankEditMain />}
          />
        </Route>
        <Route
          path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_bank_details_success/:id"
          element={<FeatureNotAssign userServices={"FFUAccount"} />}
        >
          <Route
            path="/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_bank_details_success/:id"
            element={<FieldForceBankEditSuccess />}
          />
        </Route>
        {/* This is required for https://projects.resources.xpentra.com/wp/26942 */}
        <Route
          exact
          path="/settings/users"
          element={
            <>
              <Navigate to="/settings/user_view_all" />
            </>
          }
        />
        <Route
          path="/settings/user_view_all/user_detail_page/:id"
          element={<UserDetails userServices={"VSpecificEmp"} />}
        />
        <Route
          path="/settings/user_view_all/user_detail_page/edit_user/:id"
          element={<FeatureNotAssign userServices={"VSpecificEmp"} />}
        >
          <Route
            path="/settings/user_view_all/user_detail_page/edit_user/:id"
            element={
              <>
                <UserEditContact />
              </>
            }
          />
        </Route>
        <Route
          path="/settings/user_view_all/user_detail_page/contact_details_success/:id"
          element={<UserEditContactSuccess />}
        />
        <Route
          path="/settings/user_view_all/user_detail_page/contact_details_error/:id"
          element={<UserEditContactError />}
        />
        <Route
          path="/settings/role_view_all/role_detail_page/:id"
          element={<RolesDetails />}
        />
        <Route
          path="/settings/users/create_user"
          element={<FeatureNotAssign userServices={"CEmp"} />}
        >
          <Route path="/settings/users/create_user" element={<CreateUsers />} />
        </Route>
        <Route
          path="/settings/users/create_user/success/:id"
          element={<UserSucess />}
        />
        <Route
          path="/settings/users/create_user/error"
          element={<UserError />}
        />
        <Route
          path="/settings/service_view_all/service_detail_page/:id"
          element={<ServiceDetails />}
        />
        <Route
          path="/settings/devices_view_all"
          element={<FeatureNotAssign userServices={"Sup_VDevice"} />}
        >
          <Route path="/settings/devices_view_all" element={<MyDevices />} />
        </Route>
        <Route
          path="/settings/devices_view_all/devices_detail_page/:deviceid"
          element={<MyDeviceDetails />}
        />
        <Route
          path="settings/feature_view_all/feature_detail_page/:user_feature_id"
          element={<FeatureNotAssign userServices={"SERVICE_VIEW_FEATURE"} />}
        >
          <Route index element={<FeaturesDetail />} />
        </Route>
        <Route
          path="/settings/devices_view_all/devices_detail_page"
          element={<FeatureNotAssign userServices={"Sup_VDevice"} />}
        >
          <Route
            path="/settings/devices_view_all/devices_detail_page"
            element={<MyDeviceDetails />}
          />
        </Route>
        <Route
          path="/settings/entities_view_all"
          element={<FeatureNotAssign userServices={"MimicEntity,VEntity"} />}
        >
          <Route
            path="/settings/entities_view_all"
            element={<EntitiesViewAll />}
          />
          <Route
            path="/settings/entities_view_all/entities_detail_page/:id"
            element={<EntityDetails />}
          />
        </Route>
        <Route
          path="/settings/CIN_verification"
          element={<FeatureNotAssign userServices={"VCIN"} />}
        >
          <Route
            path="/settings/CIN_verification"
            element={<CINVerification />}
          />
        </Route>
        <Route
          path="/settings/DIN_verification"
          element={<FeatureNotAssign userServices={"VDIN"} />}
        >
          <Route
            path="/settings/DIN_verification"
            element={<DINVerification />}
          />
        </Route>
        <Route
          path="/settings/PAN_verification"
          element={<FeatureNotAssign userServices={"VPAN"} />}
        >
          <Route
            path="/settings/PAN_verification"
            element={<PanVerification />}
          />
        </Route>
        <Route
          path="/settings/GST_verification"
          element={<FeatureNotAssign userServices={"VGSTIN"} />}
        >
          <Route
            path="/settings/GST_verification"
            element={<GSTVerification />}
          />
        </Route>
        <Route
          path="/settings/IFSC_verification"
          element={<FeatureNotAssign userServices={"VIFSC"} />}
        >
          <Route
            path="/settings/IFSC_verification"
            element={<IFSCVerification />}
          />
        </Route>
        <Route
          path="/settings/IFSC_verification/IFSC_Details/:id"
          element={<IFSCDetails />}
        />
        <Route
          path="/settings/security_center"
          element={<SettingsSecurityCenter />}
        />
        <Route
          path="/settings/security_center/TOTP_Setup"
          element={<FeatureNotAssign userServices={"PLogin"} />}
        >
          <Route
            path="/settings/security_center/TOTP_Setup"
            element={<TotpCreate />}
          />
        </Route>
        <Route path="/settings/security_center/BYOK" element={<ByokCreate />} />
        <Route path="/settings/invoices" element={<InvoicesDetail />} />
        <Route
          path="/settings/test_authorization_matrix"
          element={<TestAuthMatrix />}
        />
        <Route
          path="/settings/test_authorization_matrix/test_authorization_matrix_success"
          element={<TestAuthMatrixOutcomePage />}
        />
        <Route
          path="/settings/test_authorization_matrix/test_authorization_matrix_error"
          element={<TestAuthMatrixOutcomePage />}
        />
        <Route
          path="/settings/category_dashboard"
          element={<CustomCategoryViewAll />}
        />
        <Route
          path="/settings/category_dashboard/view_details/:id"
          element={<CustomCategoryDashboard />}
        />
        <Route
          path="/settings/category_dashboard/add_category"
          element={<CustomCategoryCreate />}
        />
        <Route
          path="/settings/category_dashboard/edit_category"
          element={<CustomCategoryCreate flow={"edit"} />}
        />
        {/*  settings end */}
        <Route path="feature_not_assigned" element={<FeatureNotAssigned />} />
        {/* mixed route */}
        {[
          "/settings/my_profile/change_password",
          "/settings/security_center/change_password",
        ].map((basePath) => (
          <Route
            key={basePath}
            path={basePath}
            element={<FeatureNotAssign userServices="PLogin" />}
          >
            <Route index element={<ChangePassword />} />
          </Route>
        ))}
        {[
          "/beneficiary_transaction_dashboard",
          "/internal_transaction_dashboard",
          "/reimbursement_transaction_dashboard",
          "/tax_transaction_dashboard",
          "/beneficiary_account_dashboard",
          "/owner_account_dashboard",
          "/internal_account_dashboard",
          "/reimbursement_account_dashboard",
          "/tax_account_dashboard",
          "/remitter_account_dashboard",
        ].map((basePath) => (
          <Route
            key={basePath}
            path={`${basePath}/generate_mis_report`}
            element={<FeatureNotAssign userServices="SMisUser" />}
          >
            <Route index element={<GenerateMISReport />} />
          </Route>
        ))}
        {/* <Route
          path="/Accounts/BBPS_Dashboard/BBPS/Detailspage/:id"
          element={<BBPS_DetailPage />}
        />
        <Route path="/accounts/BBPS_Dashboard" element={<BBPS_Dashboard />} />
        <Route path="/accounts/BBPS/create" element={<BBPS_Create />} />
        <Route path="/accounts/BBPS/Success" element={<BBPS_Success />} />
        <Route path="/accounts/BBPS/Error" element={<BBPS_Error />} />
        <Route path="/accounts/BBPS/view_all" element={<BBPS_ViewAll />} /> */}
      </Route>

      <Route
        path="*"
        element={
          <RequireAuth>
            <NotFound />
          </RequireAuth>
        }
      />
    </Route>,
  ),
);

// stub out window.console
const showConsole = sessionStorage.getItem("DEBUG_MODE");
if (process.env.REACT_APP_ENV === "prod" && !showConsole) {
  window.console = {
    log: () => {},
    error: () => {},
    warn: () => {},
    timeStamp: () => {},
  };
} else {
}
// Usage:
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <CheckConnection>
    <Provider store={store}>
      <RouterProvider router={router}></RouterProvider>
    </Provider>
  </CheckConnection>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
